// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import type { TFunction } from 'i18next';

const TRANSACTION_TYPE_KEY_BASE = 'aggregator.transaction-type';

const TRANSACTION_SUBTYPE_KEY_BASE = 'aggregator.transaction-subtype';

export const normalizeTransactionSubtypeKey = (raw: string): string =>
  raw
    .trim()
    .toLowerCase()
    .replace(/\//g, ' ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

export const getTransactionTypeLabel = (
  type: string | null | undefined,
  t: TFunction,
): string => {
  const raw = type?.trim();

  if (!raw) {
    return '-';
  }

  return t(`${TRANSACTION_TYPE_KEY_BASE}.${raw}`, {
    ns: 'aggregator',
    defaultValue: raw,
  });
};

export const getTransactionSubtypeLabel = (
  subtype: string | null | undefined,
  t: TFunction,
): string => {
  const raw = subtype?.trim();

  if (!raw) {
    return '-';
  }

  const key = normalizeTransactionSubtypeKey(raw);

  return t(`${TRANSACTION_SUBTYPE_KEY_BASE}.${key}`, {
    ns: 'aggregator',
    defaultValue: raw,
  });
};
